/* eslint-disable no-console */
// import { deleteToken, deleteUser } from "api/services/localStorage.service";
import React from "react";
import { useIdleTimer } from "react-idle-timer";
import { useNavigate } from "react-router-dom";
import { ROUTES_PATH } from "routes/Routes.Constant";

const InactivityDetector: React.FC = () => {
  const timer=Number(process.env.REACT_APP_INACTIVE_TIMER)||30;
  const navigate = useNavigate();
  const handleOnIdle = () => {
    localStorage.removeItem("UserRecord");
    navigate(ROUTES_PATH.HOMEPAGE);
  };
  useIdleTimer({
    
    timeout: 1000 * 60 *timer, 
    onIdle: handleOnIdle,
    debounce: 500,
  });
  return null;
};

export default InactivityDetector;
